import { Card } from '@/components/ui/card';

export default function QuickActionCard({ icon: Icon, title, description, color }) {
  const colorClasses = {
    primary: 'bg-primary/10 text-primary border-primary/20',
    secondary: 'bg-secondary/10 text-secondary border-secondary/20',
    accent: 'bg-accent/10 text-accent border-accent/20'
  };

  return (
    <Card className="p-5 hover:shadow-md transition-smooth group cursor-pointer border-2 hover:border-primary/30">
      <div className="flex items-start gap-4">
        <div className={`w-12 h-12 rounded-xl ${colorClasses[color]} flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-bounce`}>
          <Icon className="w-6 h-6" />
        </div>
        <div className="flex-1">
          <h4 className="font-semibold text-foreground mb-1">{title}</h4>
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>
      </div>
    </Card>
  );
}
